import { render, staticRenderFns } from "./practiceDailyDoQuestionSix.vue?vue&type=template&id=42144788&scoped=true"
import script from "./practiceDailyDoQuestionSix.vue?vue&type=script&lang=js"
export * from "./practiceDailyDoQuestionSix.vue?vue&type=script&lang=js"
import style0 from "./practiceDailyDoQuestionSix.vue?vue&type=style&index=0&id=42144788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42144788",
  null
  
)

export default component.exports